export default {
  loading: 'Loading pricing…',
  default_modal: {
    title: 'Default price list',
    description:
      'The fallback prices every partner without their own override inherits. Changes never affect running licenses.',
    saved: 'Default price list saved.',
  },
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    save: 'Save',
  },
  toasts: {
    load_error: 'Could not load the pricing data.',
    save_error: 'Could not save — please try again.',
    prices_saved: 'Price list saved.',
    license_created: 'Licence created.',
    lifecycle: {
      pause: 'Licence paused.',
      resume: 'Licence resumed.',
      cancel: 'Licence canceled.',
    },
  },
  price_book: {
    title: 'Price list',
    read_only_notice: 'Partner prices override the master default list. Running licenses keep their locked prices.',
    editing_notice: 'Editing — new prices apply to licenses created from now on only.',
    columns: {
      service: 'Service',
      cost_price: 'Gross price ({{currency}}/month, incl. VAT)',
    },
    add_ons: 'Add-ons',
    missing_price: '{{name}} is enabled but has no price — set one or disable it.',
    incomplete_tier: '{{name}} needs both a volume price and the number of live locations it applies from, or neither.',
    invalid_tier: 'The volume price of {{name}} must be below its standard price, from at least 2 live locations.',
    tier: {
      from: 'Volume price from',
      live_locations: 'live locations',
      counted_one: 'This partner counts {{count}} live licensed location toward the volume price.',
      counted_other: 'This partner counts {{count}} live licensed locations toward the volume price.',
    },
    snapshot_note:
      'Prices are locked onto a license when it is created — editing the list never changes running licenses.',
    types: {
      base: 'Base',
      add_on: 'Add-on',
    },
  },
  volume_discount: {
    title: 'Volume discount',
    read_only_notice:
      'Once a monthly invoice bills the threshold number of licences, the discount comes off all licence fees of that cycle.',
    editing_notice: 'Editing — the new dials apply from the next billing cycle on.',
    threshold_label: 'Licence threshold',
    percent_label: 'Discount',
    invalid: 'Enter a threshold of at least 1 and a discount between 0 and 100%.',
    saved: 'Volume discount saved.',
    note: 'Counts licences billed in the cycle itself; carried-over months are excluded. 0% (the default) disables the discount — otherwise it would stack on top of the volume price in the price list.',
  },
  licenses: {
    test_restaurant_unlicensable: 'A test restaurant is never billed, so it cannot hold a licence.',
    title: 'Restaurant licenses',
    select_company: 'Select a restaurant',
    add_license: 'Add license',
    no_companies: 'This partner has no restaurants yet.',
    no_licenses: 'No licenses for this restaurant yet.',
    activated_at: 'Active since',
    next_period_preview: 'Next month (prorated, before volume discount)',
    statuses: {
      active: 'Active',
      paused: 'Paused',
      canceled: 'Canceled',
    },
    columns: {
      product: 'Service',
      locked_price: 'Locked price / month',
      quantity: 'Qty',
      trial_ends: 'Free until',
    },
    price_tiers: {
      volume: 'Volume rate',
      locked: 'Legacy price',
    },
  },
  lifecycle: {
    pause: {
      action: 'Pause',
      title: 'Pause this license?',
      description: 'Paused days are not billed. The license keeps its locked prices and can be resumed anytime.',
      confirm: 'Pause',
    },
    resume: {
      action: 'Resume',
      title: 'Resume this license?',
      description: 'Billing continues from today at the locked prices.',
      confirm: 'Resume',
    },
    cancel: {
      action: 'Cancel license',
      title: 'Cancel this license?',
      description:
        'The current month is billed pro-rata up to today. This cannot be undone — a new license would be created at current list prices.',
      confirm: 'Cancel license',
    },
  },
  add_license: {
    title: 'Add a license',
    description: 'Select the services for this restaurant. Prices are locked onto the license at creation.',
    per_month: ' / month',
    create: 'Create license',
    no_priced_products: 'No products have a usable price for this partner yet — set the price list first.',
  },
};
